import styled from 'styled-components';

export const SubmitActionBlocker = styled.div`
  position: fixed;
  z-index: 9999;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
`;
